import { environment } from '../../../../environments/environment';
// import * as angular from 'angular';

(function () {
  'use strict';

  angular.module('app').service('CreditPaymentTermService', CreditPaymentTermService);

  CreditPaymentTermService.$inject = [
    'RestResource',
    'CONFIGURATIONS',
    '$translate',
    '$filter',
    'UtilService',
    'SessionService',
    'CreditPaymentTermModalService',
    'WindowModalService',
    'TranslationModalService',
  ];

  function CreditPaymentTermService(
    RestResource,
    config,
    $translate,
    $filter,
    UtilService,
    SessionService,
    CreditPaymentTermModalService,
    WindowModalService,
    TranslationModalService
  ) {
    var utils = new UtilService(this);

    $translate = $filter('translate');

    var apiUrl = environment.apiEndpoint + 'companies';

    var service = {
      getFilterCriteria: getFilterCriteria,
      getCreditPaymentTerms: getCreditPaymentTerms,
      getCreditPaymentTerm: getCreditPaymentTerm,
      saveCreditPaymentTerm: saveCreditPaymentTerm,
      openCreditPaymentTermModal: openCreditPaymentTermModal,
      changeCreditPaymentTermStatus: changeCreditPaymentTermStatus,
      setDefaultCreditPaymentTerm: setDefaultCreditPaymentTerm,
      deleteCreditPaymentTerm: deleteCreditPaymentTerm,
      openCreditPaymentTermsModal: openCreditPaymentTermsModal,
      openCreditPaymentTermTranslations: openCreditPaymentTermTranslations,
    };

    return service;

    ////////////////

    function getFilterCriteria() {
      var filterCriteria = {
        page: 1,
        sortDir: 'days',
        sortedBy: 'name',
      };

      return filterCriteria;
    }

    function openCreditPaymentTermTranslations(creditPaymentTerm, additionalLanguages) {
      var template =
        './app/ajs/credit-payment-terms/modals/credit-payment-term-detail-translation.html';

      var modalParams = {
        title: creditPaymentTerm.name,
        item: creditPaymentTerm,
        additionalLanguages: additionalLanguages,
      };

      var initializeCallback = function (itemId, language) {
        return getCreditPaymentTerm(itemId, language, 'translate').then(function (data) {
          return data;
        });
      };

      var confirmCallback = function (paymentMethod, language) {
        return saveCreditPaymentTerm(paymentMethod, language).then(function (data) {
          if (!data.status) {
            return data.response;
          }

          return false;
        });
      };

      TranslationModalService.open(template, modalParams, initializeCallback, confirmCallback);
    }

    function getCreditPaymentTerms(filterCriteria) {
      if (!filterCriteria) {
        filterCriteria = getFilterCriteria();
      }

      var url =
        apiUrl + '/' + SessionService.getSelectedAccountCompany().id + '/credit_payment_terms';

      return RestResource.request(
        'get',
        url,
        filterCriteria,
        function (response) {
          return response.data;
        },
        {}
      );
    }

    function getCreditPaymentTerm(id, language, translate) {
      var params = { lang: null, get: null };

      if (language) {
        params.lang = language;
      }

      if (translate) {
        params.get = 'translate';
      }

      var url =
        apiUrl +
        '/' +
        SessionService.getSelectedAccountCompany().id +
        '/credit_payment_terms/' +
        id;

      return RestResource.request(
        'get',
        url,
        params,
        function (response) {
          return response.data;
        },
        function () {
          return false;
        }
      );
    }

    function saveCreditPaymentTerm(creditPaymentTerm, language) {
      var url =
        apiUrl + '/' + SessionService.getSelectedAccountCompany().id + '/credit_payment_terms';
      var method = 'post';

      if (creditPaymentTerm.id) {
        // edit
        url += '/' + creditPaymentTerm.id;
        method = 'put';
      }

      var lang = language ? language : config.DEFAULT_CONTENT_LANGUAGE;

      function success(response) {
        var msg = !creditPaymentTerm.id
          ? 'CREDIT_PAYMENT_TERM_ADDED'
          : 'CREDIT_PAYMENT_TERM_MODIFIED';
        utils._successMsg($translate(msg));

        return {
          status: true,
          response: response.data,
        };
      }

      function failure(response) {
        return {
          status: false,
          response: response.data,
        };
      }

      return RestResource.request(
        method,
        url,
        { credit_payment_term: creditPaymentTerm, lang: lang },
        success,
        failure
      );
    }

    function openCreditPaymentTermModal(
      creditPaymentTerm,
      defaultLanguage,
      additionalLanguages,
      mode,
      successCallback
    ) {
      var templateUrl =
        './app/ajs/credit-payment-terms/modals/credit-payment-term-detail-modal.html';

      var title = !creditPaymentTerm.id ? 'ADD_CREDIT_PAYMENT_TERM' : 'CREDIT_PAYMENT_TERM_DETAILS';

      var originalItem = angular.copy(creditPaymentTerm);

      var modalParams = {
        title: title,
        item: originalItem,
        mode: mode,
        defaultLanguage: defaultLanguage,
        additionalLanguages: additionalLanguages,
        preventModalClose: true,
      };

      //if (!creditPaymentTerm.id){
      //    modalParams.closeOnSave = false; // Do not close modal after create
      //}

      var confirmCallback = function (response) {
        if (creditPaymentTerm.id) {
          // Edit
          creditPaymentTerm.name = response.name;
          creditPaymentTerm.days = response.days;

          return utils.itemListChanged(response.id);
        }

        return successCallback(response);
      };

      WindowModalService.open(templateUrl, modalParams, confirmCallback);
    }

    function changeCreditPaymentTermStatus(creditPaymentTerm) {
      var url =
        apiUrl +
        '/' +
        SessionService.getSelectedAccountCompany().id +
        '/credit_payment_terms/' +
        creditPaymentTerm.id;

      var params = { title: null, body: null, successMsg: null };

      if (creditPaymentTerm.status) {
        params.title = 'DEACTIVATE_CREDIT_PAYMENT_TERM';
        params.body = 'DEACTIVATING_CREDIT_PAYMENT_TERM_WARNING';
        params.successMsg = 'CREDIT_PAYMENT_TERM_MODIFIED';
      }

      utils.changeItemStatus(url, creditPaymentTerm, params);
    }

    function setDefaultCreditPaymentTerm(creditPaymentTerm, successCallback) {
      var url = `${apiUrl}/${SessionService.getSelectedAccountCompany().id}/credit_payment_terms/${
        creditPaymentTerm.id
      }`;

      creditPaymentTerm.is_default = true;

      var params = {
        credit_payment_term: creditPaymentTerm,
        set_default: true,
      };

      return RestResource.request(
        'put',
        url,
        params,
        function (response) {
          var msg = $translate('DEFAULT_CREDIT_PAYMENT_TERM_CHANGED');
          utils._successMsg(msg);

          return successCallback();
        },
        function (response) {
          utils._errorMsg(response.data.error);
          return false;
        }
      );
    }

    function deleteCreditPaymentTerm(creditPaymentTerm, successCallback) {
      var url =
        apiUrl +
        '/' +
        SessionService.getSelectedAccountCompany().id +
        '/credit_payment_terms/' +
        creditPaymentTerm.id;

      var params = {
        title: 'DELETE_CREDIT_PAYMENT_TERM',
        body: 'DELETING_CREDIT_PAYMENT_TERM_WARNING',
        // reason:     'DELETE_ITEM_REASON',
        successMsg: 'CREDIT_PAYMENT_TERM_DELETED',
      };

      utils.deleteItem(url, successCallback, params);
    }

    function openCreditPaymentTermsModal(creditPaymentTerms, companyId, successCallback) {
      CreditPaymentTermModalService.openCreditPaymentTermsModal(
        creditPaymentTerms,
        companyId,
        successCallback
      );
    }
  }
})();
